<template>
  <span style="font-family: ZapfDingbats">&#x274F;</span>
</template>

<script>
export default {
  name: "BoxZ",
  props: ["boxz"]
};
</script>
